export default {
  // Page title and navigation
  'pages.electric-fee.title': 'Electricity Fee',
  'pages.electric-fee.subtitle': 'Manage community electricity bill generation, payment and inquiry',
  'pages.electric-fee.currentSelection': 'Current selection:',
  'pages.electric-fee.batchImport': 'Batch Import',
  'pages.electric-fee.treeTitle': 'Building Floor House Selection',

  // Page method comments and error messages
  'pages.electric-fee.loadRecentMonths.comment': 'Load the list of recent six months',
  'pages.electric-fee.loadRecentMonths.error': 'Failed to load the list of recent six months',
  'pages.electric-fee.setDefaultTab.comment': 'Only set default value when activeTabKey is empty',
  'pages.electric-fee.setDefaultTab.defaultComment': 'Set default tab',
  'pages.electric-fee.loadTreeData.comment': 'Load building floor house tree data',
  'pages.electric-fee.loadTreeData.error': 'Failed to load building floor house data',
  'pages.electric-fee.expandFirstBuilding.comment': 'Expand the first building by default',
  'pages.electric-fee.activeTabChange.comment': 'Refresh table after activeTabKey is first set',
  'pages.electric-fee.treeSelect.comment': 'Tree selection handling',
  'pages.electric-fee.selectBuilding.comment': 'Select building',
  'pages.electric-fee.selectFloor.comment': 'Select floor',
  'pages.electric-fee.findBuildingName.comment': 'Find building name',
  'pages.electric-fee.selectHouse.comment': 'Select house',
  'pages.electric-fee.findBuildingFloorName.comment': 'Find building and floor name',
  'pages.electric-fee.refreshTable.comment': 'Refresh right table',
  'pages.electric-fee.generateSubTitle.comment': 'Generate subtitle',
  'pages.electric-fee.importSuccessCallback.comment': 'Import success callback',
  'pages.electric-fee.leftTree.comment': 'Left building floor tree',
  'pages.electric-fee.rightList.comment': 'Right electricity fee list',
  'pages.electric-fee.batchImportModal.comment': 'Batch import modal',

  // Floor name concatenation
  'pages.electric-fee.floorSuffix': '',

  // Breadcrumb navigation
  'pages.breadcrumb.chargeManagement': 'Charge Management',
  'pages.breadcrumb.electricFee': 'Electricity Fee',

  // Table related
  'pages.electric-fee.table.title': 'Electricity Bill List',
  'pages.electric-fee.table.houseInfo': 'House Info',
  'pages.electric-fee.table.period': 'Period',
  'pages.electric-fee.table.billNo': 'Bill No',
  'pages.electric-fee.table.elecUsage': 'Electricity Usage(kWh)',
  'pages.electric-fee.table.totalAmount': 'Total Amount',
  'pages.electric-fee.table.approvalStatus': 'Approval Status',
  'pages.electric-fee.table.paymentStatus': 'Payment Status',
  'pages.electric-fee.table.paymentTime': 'Payment Time',
  'pages.electric-fee.table.dueDate': 'Due Date',
  'pages.electric-fee.table.action': 'Action',

  // Action buttons
  'pages.electric-fee.action.view': 'View',
  'pages.electric-fee.action.edit': 'Edit',
  'pages.electric-fee.action.delete': 'Delete',
  'pages.electric-fee.action.create': 'Create Bill',
  'pages.electric-fee.action.submitAudit': 'Submit Audit',
  'pages.electric-fee.action.batchDelete': 'Batch Delete',
  'pages.electric-fee.action.confirm': 'Confirm',
  'pages.electric-fee.action.cancel': 'Cancel',

  // Delete related
  'pages.electric-fee.delete.confirmTitle': 'Are you sure you want to delete this record?',
  'pages.electric-fee.delete.success': 'Delete successful',
  'pages.electric-fee.delete.failure': 'Delete failed',
  'pages.electric-fee.batchDelete.confirmTitle': 'Confirm Batch Delete',
  'pages.electric-fee.batchDelete.confirmMessage': 'Are you sure you want to delete the selected {count} records?',
  'pages.electric-fee.batchDelete.success': 'Batch delete successful',
  'pages.electric-fee.batchDelete.failure': 'Batch delete failed',

  // Audit related
  'pages.electric-fee.audit.selectBillsWarning': 'Please select bills to submit for audit',
  'pages.electric-fee.audit.modalTitle': 'Submit for Audit',
  'pages.electric-fee.audit.submitAudit': 'Submit for Audit',
  'pages.electric-fee.audit.auditName': 'Audit Name',
  'pages.electric-fee.audit.auditNamePlaceholder': 'Please enter audit name',
  'pages.electric-fee.audit.auditNameRequired': 'Please enter audit name',
  'pages.electric-fee.audit.submitRemark': 'Submission Notes',
  'pages.electric-fee.audit.submitRemarkPlaceholder': 'Please enter submission notes (optional)',
  'pages.electric-fee.audit.selectedBillsTitle': 'Selected bills list (total {count} items)',
  'pages.electric-fee.audit.success': 'Submit audit successful',
  'pages.electric-fee.audit.failure': 'Submit audit failed',
  'pages.electric-fee.audit.defaultName': '{period} Electricity Bills ({count} items)',

  // Detail modal
  'pages.electric-fee.detail.modalTitle': 'Electricity Bill Details',
  'pages.electric-fee.detail.close': 'Close',

  // Detail fields
  'pages.electric-fee.detail.billNo': 'Bill No',
  'pages.electric-fee.detail.period': 'Period',
  'pages.electric-fee.detail.paymentStatus': 'Payment Status',
  'pages.electric-fee.detail.approvalStatus': 'Approval Status',
  'pages.electric-fee.detail.startDate': 'Start Date',
  'pages.electric-fee.detail.endDate': 'End Date',
  'pages.electric-fee.detail.houseInfo': 'House Info',
  'pages.electric-fee.detail.ownerInfo': 'Owner Info',
  'pages.electric-fee.detail.ownerIdCard': 'ID Card',
  'pages.electric-fee.detail.ownerEmail': 'Email',
  'pages.electric-fee.detail.ownerId': 'Owner ID',
  'pages.electric-fee.detail.lastReading': 'Last Reading(kWh)',
  'pages.electric-fee.detail.lastReadingDate': 'Last Reading Date',
  'pages.electric-fee.detail.currentReading': 'Current Reading(kWh)',
  'pages.electric-fee.detail.currentReadingDate': 'Current Reading Date',
  'pages.electric-fee.detail.elecUsage': 'Electricity Usage',
  'pages.electric-fee.detail.unitPrice': 'Unit Price(PHP/kWh)',
  'pages.electric-fee.detail.baseAmount': 'Base Amount',
  'pages.electric-fee.detail.lateFee': 'Late Fee',
  'pages.electric-fee.detail.discountAmount': 'Discount Amount',
  'pages.electric-fee.detail.finalAmount': 'Final Amount',
  'pages.electric-fee.detail.paymentMethod': 'Payment Method',
  'pages.electric-fee.detail.paymentReference': 'Payment Reference',
  'pages.electric-fee.detail.dueDate': 'Due Date',
  'pages.electric-fee.detail.paymentDate': 'Payment Date',
  'pages.electric-fee.detail.createdTime': 'Created Time',
  'pages.electric-fee.detail.updatedTime': 'Updated Time',
  'pages.electric-fee.detail.remarks': 'Remarks',

  // Detail modal hardcoded texts
  'pages.electric-fee.detail.basicInfo': 'Basic Information',
  'pages.electric-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.electric-fee.detail.meterReadingInfo': 'Meter Reading Information',
  'pages.electric-fee.detail.amountInfo': 'Amount Information',
  'pages.electric-fee.detail.paymentInfo': 'Payment Information',
  'pages.electric-fee.detail.systemInfo': 'System Information',
  'pages.electric-fee.detail.auditRecord': 'Audit Records',
  'pages.electric-fee.detail.loading': 'Loading...',
  'pages.electric-fee.detail.noAuditRecord': 'No audit records',

  // Form related
  'pages.electric-fee.form.editTitle': 'Edit Electricity Bill',
  'pages.electric-fee.form.createTitle': 'Create Electricity Bill',
  'pages.electric-fee.form.basicInfo': 'Basic Information',
  'pages.electric-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.electric-fee.form.meterReadingInfo': 'Electricity Meter Reading Information',
  'pages.electric-fee.form.feeInfo': 'Fee Information',
  'pages.electric-fee.form.remarksInfo': 'Remarks Information',
  'pages.electric-fee.form.update': 'Update',
  'pages.electric-fee.form.create': 'Create',
  'pages.electric-fee.form.cancel': 'Cancel',

  // Form fields
  'pages.electric-fee.form.billNo': 'Bill No',
  'pages.electric-fee.form.billNoPlaceholder': 'Please enter bill number',
  'pages.electric-fee.form.paymentStatus': 'Payment Status',
  'pages.electric-fee.form.paymentStatusPlaceholder': 'Please select payment status',
  'pages.electric-fee.form.period': 'Period',
  'pages.electric-fee.form.periodPlaceholder': 'e.g.: 2024-01',
  'pages.electric-fee.form.periodRequired': 'Please enter period',
  'pages.electric-fee.form.startDate': 'Start Date',
  'pages.electric-fee.form.startDatePlaceholder': 'Please select start date',
  'pages.electric-fee.form.startDateRequired': 'Please select start date',
  'pages.electric-fee.form.endDate': 'End Date',
  'pages.electric-fee.form.endDatePlaceholder': 'Please select end date',
  'pages.electric-fee.form.endDateRequired': 'Please select end date',
  'pages.electric-fee.form.building': 'Building',
  'pages.electric-fee.form.buildingPlaceholder': 'Please select building',
  'pages.electric-fee.form.buildingRequired': 'Please select building',
  'pages.electric-fee.form.floor': 'Floor',
  'pages.electric-fee.form.floorPlaceholder': 'Please select floor',
  'pages.electric-fee.form.floorRequired': 'Please select floor',
  'pages.electric-fee.form.house': 'House',
  'pages.electric-fee.form.housePlaceholder': 'Please select house',
  'pages.electric-fee.form.houseRequired': 'Please select house',
  'pages.electric-fee.form.lastReading': 'Last Reading',
  'pages.electric-fee.form.lastReadingPlaceholder': 'Please enter last reading',
  'pages.electric-fee.form.lastReadingDate': 'Last Reading Date',
  'pages.electric-fee.form.lastReadingDatePlaceholder': 'Please select last reading date',
  'pages.electric-fee.form.currentReading': 'Current Reading',
  'pages.electric-fee.form.currentReadingPlaceholder': 'Please enter current reading',
  'pages.electric-fee.form.currentReadingRequired': 'Please enter current reading',
  'pages.electric-fee.form.currentReadingDate': 'Current Reading Date',
  'pages.electric-fee.form.currentReadingDatePlaceholder': 'Please select current reading date',
  'pages.electric-fee.form.currentReadingDateRequired': 'Please select current reading date',
  'pages.electric-fee.form.elecUsage': 'Electricity Usage',
  'pages.electric-fee.form.elecUsageAuto': 'Auto calculated',
  'pages.electric-fee.form.unitPrice': 'Unit Price',
  'pages.electric-fee.form.unitPricePlaceholder': 'Please enter unit price',
  'pages.electric-fee.form.unitPriceRequired': 'Please enter unit price',
  'pages.electric-fee.form.baseAmount': 'Base Amount',
  'pages.electric-fee.form.baseAmountAuto': 'Auto calculated',
  'pages.electric-fee.form.lateFee': 'Late Fee',
  'pages.electric-fee.form.lateFeePlaceholder': 'Please enter late fee',
  'pages.electric-fee.form.discountAmount': 'Discount Amount',
  'pages.electric-fee.form.discountAmountPlaceholder': 'Please enter discount amount',
  'pages.electric-fee.form.finalAmount': 'Final Amount',
  'pages.electric-fee.form.finalAmountAuto': 'Auto calculated',
  'pages.electric-fee.form.finalAmountRequired': 'Final amount will be auto calculated',
  'pages.electric-fee.form.remarks': 'Remarks',
  'pages.electric-fee.form.remarksPlaceholder': 'Please enter remarks',
  'pages.electric-fee.form.remarksMaxLength': 'Remarks length cannot exceed 500 characters',

  // Form validation and error messages
  'pages.electric-fee.form.serviceNotAvailable': 'This house does not have electricity service enabled, please select another house',
  'pages.electric-fee.form.loadPriceConfigError': 'Failed to load electricity price configuration',
  'pages.electric-fee.form.submitSuccess': 'Create successful',
  'pages.electric-fee.form.updateSuccess': 'Update successful',
  'pages.electric-fee.form.submitError': 'Submit failed',

  // Currency unit
  'pages.electric-fee.currency.php': 'PHP',

  // Pagination
  'pages.electric-fee.table.pagination.showTotal': 'Items {start}-{end} of {total}',

  // Import related
  'pages.electric-fee.import.modalTitle': 'Batch Import Electricity Bills',
  'pages.electric-fee.import.confirmImport': 'Confirm Import',
  'pages.electric-fee.import.cancel': 'Cancel',
  'pages.electric-fee.import.step1': 'Step 1: Download Import Template',
  'pages.electric-fee.import.downloadTemplate': 'Download Electricity Bill Excel Template',
  'pages.electric-fee.import.step2': 'Step 2: Select Period and Upload Completed Excel File',
  'pages.electric-fee.import.selectPeriod': 'Select Period:',
  'pages.electric-fee.import.selectPeriodPlaceholder': 'Please select period',
  'pages.electric-fee.import.uploadFile': 'Upload File:',
  'pages.electric-fee.import.uploadHint': 'Click or drag Excel file to this area',
  'pages.electric-fee.import.uploadFormatHint': 'Only .xls and .xlsx Excel files are supported, file size cannot exceed 10MB',
  'pages.electric-fee.import.notices': 'Notes:',
  'pages.electric-fee.import.notice1': 'Please select period and Excel file first, then click "Confirm Import" button',
  'pages.electric-fee.import.notice2': 'Please download template and fill in data according to template format',
  'pages.electric-fee.import.notice3': 'Required fields cannot be empty',
  'pages.electric-fee.import.notice4': 'Please follow the date format examples in the template',
  'pages.electric-fee.import.notice5': 'Please check data accuracy before importing',
  'pages.electric-fee.import.notice6': 'If any row has abnormal data, that data will not be imported',
  'pages.electric-fee.import.notice7': 'If data already exists, it will not be imported',
  'pages.electric-fee.import.notice8': 'Large data imports may be slow, please be patient',
  'pages.electric-fee.import.successTitle': 'Import Request Submitted',
  'pages.electric-fee.import.successMessage': 'Data is being imported, please refresh the page later to view import results!',
  'pages.electric-fee.import.selectPeriodFirst': 'Please select period first!',
  'pages.electric-fee.import.selectFileFirst': 'Please select Excel file to upload!',
  'pages.electric-fee.import.invalidFile': 'Invalid file, please reselect!',
  'pages.electric-fee.import.importFailed': 'Import failed, please check file format',
  'pages.electric-fee.import.downloadSuccess': 'Template download successful',
  'pages.electric-fee.import.downloadFailed': 'Template download failed',
  'pages.electric-fee.import.downloadFormatError': 'Downloaded file format is incorrect',
  'pages.electric-fee.import.downloadEmptyError': 'Downloaded file is empty',
  'pages.electric-fee.import.fileSizeError': 'File size cannot exceed 10MB!',
  'pages.electric-fee.import.templateFileName': 'Electricity Bill Template_{timestamp}.xlsx',

  // Period query modal
  'pages.electric-fee.period.modalTitle': 'Room Query - {houseName} - Period {period}',
  'pages.electric-fee.period.noData': 'No Data',
  'pages.electric-fee.period.elecUsage': 'Electricity Usage',
  'pages.electric-fee.period.currentMonthUsage': 'Current Month Usage',
  'pages.electric-fee.period.currentMonthAmount': 'Current Month Amount',
  'pages.electric-fee.period.avgUsage': 'Average Usage',
  'pages.electric-fee.period.currentMonthPrice': 'Current Month Price',
  'pages.electric-fee.period.usageChange': 'Usage Change',
  'pages.electric-fee.period.vsLastMonth': 'vs Last Month',
  'pages.electric-fee.period.noComparisonData': 'No Comparison Data',
  'pages.electric-fee.period.amountChange': 'Amount Change',
  'pages.electric-fee.period.vsLastMonthAmount': 'vs Last Month Amount',
  'pages.electric-fee.period.avgPrice': 'Average Price',
  'pages.electric-fee.period.pricePerKwh': 'Per kWh (incl. service fee)',
  'pages.electric-fee.period.usageTrendTitle': 'Last 6 Months Usage Trend',
  'pages.electric-fee.period.amountTrendTitle': 'Last 6 Months Amount Trend',
  'pages.electric-fee.period.detailTableTitle': 'Monthly Detailed Data',
  'pages.electric-fee.period.month': 'Month',
  'pages.electric-fee.period.unitPrice': 'Unit Price(PHP/kWh)',
  'pages.electric-fee.period.amount': 'Amount(PHP)',
  'pages.electric-fee.period.lateFee': 'Late Fee(PHP)',
  'pages.electric-fee.period.discountAmount': 'Discount Amount(PHP)',
  'pages.electric-fee.period.finalAmount': 'Final Amount(PHP)',
  'pages.electric-fee.period.status': 'Status',

  // Status related
  'pages.electric-fee.status.unpaid': 'Unpaid',
  'pages.electric-fee.status.paid': 'Paid',
  'pages.electric-fee.status.overdue': 'Overdue',
  'pages.electric-fee.status.partial': 'Partial',
  'pages.electric-fee.status.cancelled': 'Cancelled',

  // Approval status
  'pages.electric-fee.approvalStatus.draft': 'Draft',
  'pages.electric-fee.approvalStatus.pending': 'Pending',
  'pages.electric-fee.approvalStatus.approved': 'Approved',
  'pages.electric-fee.approvalStatus.rejected': 'Rejected',
  'pages.electric-fee.approvalStatus.notified': 'Notified',
  'pages.electric-fee.approvalStatus.overdue': 'Overdue',
  'pages.electric-fee.approvalStatus.cancelled': 'Cancelled',

  // Units
  'pages.electric-fee.unit.kwh': 'kWh',
  'pages.electric-fee.unit.phpPerKwh': 'PHP/kWh',

  // Detail Component Fields
  'pages.electric-fee.detail.basicInfo': 'Basic Information',
  'pages.electric-fee.detail.billNo': 'Bill Number',
  'pages.electric-fee.detail.period': 'Period',
  'pages.electric-fee.detail.paymentStatus': 'Payment Status',
  'pages.electric-fee.detail.approvalStatus': 'Approval Status',
  'pages.electric-fee.detail.startDate': 'Start Date',
  'pages.electric-fee.detail.endDate': 'End Date',
  'pages.electric-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.electric-fee.detail.houseInfo': 'House Information',
  'pages.electric-fee.detail.ownerInfo': 'Owner Information',
  'pages.electric-fee.detail.meterReadingInfo': 'Meter Reading Information',
  'pages.electric-fee.detail.lastReading': 'Last Reading',
  'pages.electric-fee.detail.lastReadingDate': 'Last Reading Date',
  'pages.electric-fee.detail.currentReading': 'Current Reading',
  'pages.electric-fee.detail.currentReadingDate': 'Current Reading Date',
  'pages.electric-fee.detail.elecUsage': 'Electricity Usage',
  'pages.electric-fee.detail.unitPrice': 'Unit Price',
  'pages.electric-fee.detail.amountInfo': 'Amount Information',
  'pages.electric-fee.detail.baseAmount': 'Base Amount',
  'pages.electric-fee.detail.lateFee': 'Late Fee',
  'pages.electric-fee.detail.discountAmount': 'Discount Amount',
  'pages.electric-fee.detail.finalAmount': 'Final Amount',
  'pages.electric-fee.detail.paymentInfo': 'Payment Information',
  'pages.electric-fee.detail.paymentMethod': 'Payment Method',
  'pages.electric-fee.detail.paymentReference': 'Payment Reference',
  'pages.electric-fee.detail.dueDate': 'Due Date',
  'pages.electric-fee.detail.paymentDate': 'Payment Date',
  'pages.electric-fee.detail.systemInfo': 'System Information',
  'pages.electric-fee.detail.createdTime': 'Created Time',
  'pages.electric-fee.detail.updatedTime': 'Updated Time',
  'pages.electric-fee.detail.remarks': 'Remarks',
};
